import { Divider, PageHeadline } from 'components/elements';
import { useFind } from 'components/hooks';
import { ReadOnly } from 'components/modules';
import fp from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { useMount } from 'react-use';
import { ExchangeResources } from 'services/resources/catalogs/exchange';
import { IReadOnlyResource } from 'services/resources/catalogs/types.d';

export const ExchangePage: React.FC = (): JSX.Element => {
  const [state, onFind] = useFind<IReadOnlyResource>(ExchangeResources);

  const { t } = useTranslation('common');

  useMount(() => onFind());

  return (
    <>
      <PageHeadline
        quote={t('page.read-only.quote')}
        title={t('page.exchange.title')}
      />

      <Divider />

      <ReadOnly data={fp.get(['value', 'results'])(state)} m={8} />
    </>
  );
};
